import {Component} from '@angular/core';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-global-constants',
    templateUrl: './global-constants.component.html',
    styleUrls: ['./global-constants.component.scss'],
    standalone: true,
})
export class GlobalConstantsComponent {
  public static apiURL: string = environment.apiURL;
  public static api2URL: string = environment.api2URL;
  public static tekloUrl: string = environment.tekloURL;
  public static mediaURL: string = environment.mediaURL;
  public static rawMediaURL: string = environment.rawMediaURL;
  public static mediaFilesURL: string = environment.mediaFilesURL;
  public static mixpanelToken: string = environment.mixpanelToken;
  public static payPalId: string = environment.payPalId;
  public static ueCountries = [
    'DE',
    'AT',
    'BE',
    'BG',
    'CY',
    'HR',
    'DK',
    'ES',
    'EE',
    'FI',
    'FR',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'CZ',
    'RO',
    'SK',
    'SI',
    'SE',
    'CH',
    'LI',
    'IS',
    'NO'
  ];
  public static visaTypes = [
    { text: "VISA_TYPES.LONG_STAY_TRAINEE", key: 'vls-stagiaire' },
    { text: "VISA_TYPES.LONG_STAY_VLS_TS", key: 'vls-ts' },
    { text: "VISA_TYPES.LONG_STAY_TALENT", key: 'vls-chercheur' },
    { text: "VISA_TYPES.TEMP_STAY_VLS_T", key: 'vls-t' },
    { text: "VISA_TYPES.SHORT_STAY_STUDENT", key: 'vcs-etudiant' },
    { text: "VISA_TYPES.ASK_CARD", key: 'visa-carte' },
    { text: "VISA_TYPES.LONG_TEMP_STAY",key: 'vls-t-small'},
    { text: "VISA_TYPES.WORK_HOLIDAYS", key: 'vacances-travail' },
    { text: "VISA_TYPES.MINOR_STUDENT", key: 'etudiant-mineur' },
    { text: "VISA_TYPES.SCHENGEN", key: 'schengen' },
    { text: "VISA_TYPES.MOVEMENT", key: 'circulation' },
  ];

  public static cafAddress = [
    {
      text:
        'Bordeaux : Caf de Gironde - Rue du Docteur-Gabriel-Péry, 33078 Bordeaux.',
      key: 'bordeaux',
    },
    {
      text: 'Grenoble : CAF de l’isère - 3 rue des Alliés, 38000 Grenoble.',
      key: 'grenoble',
    },
    {
      text: 'Lille : CAF de Lille - 82 rue brûle Maison, 59800 Lille.',
      key: 'lille',
    },
    {
      text:
        'Lyon : CAF du Rhône - 67 Boulevard Vivier Merle, 69409 Lyon Cedex 3.',
      key: 'lyon',
    },
    {
      text:
        'Marseille : CAF des Bouches-du-Rhones - 215 chemin de Gibbes, 13000 Marseille.',
      key: 'marseille',
    },
    {
      text:
        'Montpellier : CAF de Montpellier - 139 avenue de Lodève, 34080 Montpellier.',
      key: 'montpellier',
    },
    {
      text:
        'Nantes : CAF de Loire Atlantiques - 22 rue de Malville, 44200 Nantes.',
      key: 'nantes',
    },
    {
      text:
        'Nice : CAF des Alpes Maritimes - 47 avenue de la Marne, 06100 Nice.',
      key: 'nice',
    },
    { text: 'Paris : CAF de Paris - 75656 Paris Cedex 13.', key: 'paris' },
    {
      text: 'Strasbourg : CAF du Bas Rhin - 18 rue de Berne, 67000 Strasbourg.',
      key: 'strasbourg',
    },
    {
      text:
        'Toulouse : CAF de la Haute Garonne - 24 rue Riquet, 31500 Toulouse.',
      key: 'toulouse',
    },
  ];

  // Bot détection
  public static crawlerAgents = [
    'googlebot', 'yandexbot', 'yahoo', 'bingbot',
    'baiduspider', 'facebookexternalhit', 'twitterbot', 'rogerbot',
    'linkedinbot', 'embedly', 'quora link preview', 'showyoubot', 'outbrain',
    'pinterest/0.', 'developers.google.com/+/web/snippet',
    'slackbot', 'vkshare', 'w3c_validator', 'redditbot', 'applebot',
    'whatsapp', 'flipboard', 'tumblr', 'bitlybot', 'skypeuripreview',
    'nuzzel', 'discordbot', 'google page speed'
  ];
}
